import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { STALLS, HUB_RULES } from '../../data/games';
import { apiPost } from '../../utils/apiClient';
import { setCoinsLeft } from '../../store/uiSlice';
import { setReportId } from '../../store/authSlice';
import { addReportToServer } from '../../functions/sendReport';
import useDesktopBg from '../../hooks/useDesktopBg';
import './HubPage.css';

export default function HubPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const coinsLeft = useSelector((s) => s.ui.coinsLeft);
  const bg = useDesktopBg('/img/games-background.jpg', '/img/games-background.jpg');

  useEffect(() => {
    if (!user?.userId) return;
    (async () => {
      try {
        const ensured = await apiPost('/ensureUser', {
          userId: user.userId,
          name: user.name,
          email: user.email,
        });
        dispatch(setCoinsLeft(ensured.coins_left ?? 0));

        if (ensured.reportid) {
          dispatch(setReportId(ensured.reportid));
        }

        // First visit: create ExtraMile report once, then always UPDATE on game finishes
        if (ensured.created) {
          await addReportToServer(
            { ...user, reportId: ensured.reportid || user.reportId || null },
            {
              points: 100,
              reportTime: '00:00:00',
              answers: ['harvest_start'],
              preferReportId: ensured.reportid || user.reportId || null,
              onReportId: (id) => dispatch(setReportId(id)),
            }
          );
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, [user, dispatch]);

  const openStall = (stall) => {
    const isDemo =
      user?.sessionId === 'demobypass' ||
      user?.role === 'demobypass' ||
      user?.source === 'DEMO';
    if (isDemo) {
      Swal.fire({
        title: 'Subscribe to any plan to enjoy the games.',
        icon: 'success',
        confirmButtonText: 'Close',
        customClass: { confirmButton: 'hf-swal-close', popup: 'hf-swal-popup' },
        buttonsStyling: false,
      }).then(() => {
        window.location.href = 'https://extramileplay.com/plans';
      });
      return;
    }
    navigate(stall.route);
  };

  return (
    <div className="hub-page bg-games" style={{ '--page-bg': `url(${bg})` }}>
      <div className="hub-points">Points: {coinsLeft ?? '—'}</div>
      <img src="/img/Home-page.jpg" alt="" className="hub-hero hub-hero-desk" />
      <img src="/img/Home-page-mob.jpg" alt="" className="hub-hero hub-hero-mob" />
      <div className="hub-content">
        <p className="hub-intro">
          The law of the Harvest Season is to reap more than you sow! Kickstart the season with
          planting new ideas and positive thoughts for a bigger, better and brighter harvest.
        </p>
        <div className="hub-rules-title">Follow the rules Given below to play the games</div>
        <table className="hub-rules-table">
          <tbody>
            <tr>
              <td>{HUB_RULES[0]}</td>
              <td>{HUB_RULES[1]}</td>
            </tr>
          </tbody>
        </table>
        <div className="hub-stalls">
          {STALLS.map((stall) => (
            <button
              key={stall.id}
              type="button"
              className="hub-stall"
              onClick={() => openStall(stall)}
              aria-label={stall.title}
            >
              <img src={stall.tile} alt={stall.title} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
